import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.GeneralMeetingView.heading',
    defaultMessage: 'Ogłoszenie'
  },
  return: {
    id: 'views.GeneralMeetingView.return',
    defaultMessage: 'POWRÓT'
  },
  journalistContact: {
    id: 'views.GeneralMeetingView.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  },
  filesToDownload: {
    id: 'views.GeneralMeetingView.filesToDownload',
    defaultMessage: 'ZAŁĄCZNIKI'
  },
  zipFilesToDownload: {
    id: 'views.GeneralMeetingView.zipFilesToDownload',
    defaultMessage: 'Pobierz pozostałe załączniki:'
  },
  graphicsToDownload: {
    id: 'views.GeneralMeetingView.graphicsToDownload',
    defaultMessage: 'Pobierz materiały graficzne:'
  }
});



// WEBPACK FOOTER //
// ./src/views/GeneralMeeting/GeneralMeetingView.intl.js